/**
 * This method returns `true`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `true`.
 * @example
 *
 * _.times(2, _.stubTrue);
 * // => [true, true]
 */
function stubTrue() {
  return true;
}

export default stubTrue;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/stubTrue.js
// module id = 529
// module chunks = 0